export const EHR_PERMISSIONS = 'ehr_permissions'
export const EHR_TOKEN = 'ehr_token'
export const EHR_TOKEN_EXPIRATION_DATE = 'ehr_token_expiration_date'
export const EHR_PILLARS = 'ehr/pillars'
export const EHR_LOCAL_USER = 'local_user'
export const EHR_LOGGED_USER = 'logged_user'
export const EHR_EVOLUTION_DRAFT = 'EVOLUTION_DRAFT'
export const EHR_VIDEOCALL_BACKGROUND = 'ehr_videocall_background'
export const EHR_SECOND_OPINION_WELCOME = 'view_second_opinion_welcome_card'
export const EHR_CURRENT_CHANNEL_SORT_BY_FILTER = 'channel/currentSortBy'
